import { type ICore } from "../apiClient/interfaces";
import { getCoreApiNetworkClient } from "../apiClient/networkClient";
import { useQuery } from "@tanstack/react-query";
import { SiteIsoEnum, type SiteLangEnum } from "@kunduz/utility-common";

export const useCountries = (
  lang?: SiteLangEnum,
): {
  countries: ICore.ICountry[];
  countriesLoading: boolean;
  countriesError: any;
} => {
  const apiClient = getCoreApiNetworkClient({});
  const fetcher = (url: string) => apiClient.get(url).then((res) => res.data);

  const { data, error, isLoading, isRefetching, refetch } = useQuery({
    queryKey: ["country codes", lang],
    queryFn: () => fetcher("/country-codes/"),
  });

  return {
    countries: data?.results,
    countriesLoading: isLoading,
    countriesError: error,
  };
};

export class KunduzCountry {
  id: number;
  country_name: string;
  language_name: string;
  code: number;
  currency: ICore.ICurrency;
  flag: string;
  language: string;
  config: ICore.ICountryConfig;
  iso_code: SiteIsoEnum;
  locale: string;

  public constructor(json: ICore.ICountry) {
    this.code = json.code;
    this.config = json.config;
    this.country_name = json.country_name;
    this.currency = json.currency;
    this.flag = json.flag;
    this.id = json.id;
    this.iso_code = json.iso_code;
    this.language = json.language;
    this.language_name = json.language_name;
    this.locale = json.locale;
  }

  public get i18_iso_code(): SiteLangEnum {
    return (this.language + "-" + this.iso_code) as SiteLangEnum;
  }
}
